import {useDebugValue} from 'react';

import {useOptions} from './useOptions';

const defaultMediaOptions = {
    smallBreakpoint: 768,
    largeBreakpoint: 1200
};

function useMediaOptions(props) {
    const {
        mediaOptions: propsMediaOptions
    } = props;

    const {
        options: mediaOptions
    } = useOptions(defaultMediaOptions, propsMediaOptions);

    const result = {
        mediaOptions
    };

    useDebugValue(result);

    return result;
}

export {useMediaOptions};
